import type { DialogContentProps } from '@mui/material';
import { DialogContent } from '@mui/material';

export interface ModalBodyProps extends DialogContentProps {
  hasTabbar?: boolean;
  sidebar?: React.ReactNode;
}

export const ModalBody = ({ hasTabbar, sidebar, ...props }: ModalBodyProps) => <DialogContent {...props} />;
